<ng-container *ngIf="!isVerticalDisplay; else verticalTemp">
  <button *ngFor="let lang of languageService.supportedLanguages"
          [ngClass]="{'tk-border-gray-2': !isSelected(lang.code), 'tk-border-blue': isSelected(lang.code)}"
          class="mr-2 mt-2 bg-white rounded-full hover:font-normal"
          (click)="onChangeLanguage(lang.code)">
    <div class="flex p-1">
      <div class="mr-3" [ngClass]="getIconClass(lang.code)"></div>
      <span class="self-center mr-4">{{lang.displayedName}}</span>
    </div>
  </button>
</ng-container>

<ng-template #verticalTemp>
  <div class="flex flex-col">
    <button *ngFor="let lang of languageService.supportedLanguages"
            [ngClass]="{'tk-border-2-blue': isSelected(lang.code), 'border-2 border-transparent': !isSelected(lang.code)}"
            class="mt-2 w-7 rounded-full" (click)="onChangeLanguage(lang.code)">
        <div class="" [ngClass]="getIconClass(lang.code)"></div>
    </button>
  </div>

</ng-template>
